export default __webpack_public_path__ + "static/media/DailyThing_02.5b762b9b.png";